import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-gis',
  templateUrl: './gis.component.html',
  styleUrls: ['./gis.component.scss']
})
export class GisComponent implements OnInit {

  constructor( ) { }

  stateModalDownload: boolean = false;
  stateModalDownloadDrf: boolean = false;
  stateModalDownloadNewCmp: boolean = false;

  buttonState: boolean = false;
  buttonStateDrf: boolean = false;
  buttonStateNewCmp: boolean = false;

  user: any;
  urlArcgis2: any;
  
  ngOnInit(): void {
  
    this.urlArcgis2 = JSON.parse(localStorage.getItem('gis') || '{}');
    this.user = JSON.parse(localStorage.getItem('user') || '{}');
  
    document.getElementById('idframe')?.setAttribute('src', this.urlArcgis2.url || '');
  
    const { download, typedownload } = this.urlArcgis2;
  
    this.buttonState = download && typedownload === 'cmp';
    this.buttonStateDrf = download && typedownload === 'drf';
    this.buttonStateNewCmp = download && ['trigo', 'romeral'].includes(typedownload);

    console.log('GIS');
  }

  openDownloadModal(): void {
    this.stateModalDownload = this.buttonState;
    this.stateModalDownloadDrf = this.buttonStateDrf;
    this.stateModalDownloadNewCmp = this.buttonStateNewCmp;
  }
  
  onResponseModalDownload(event: any){
    this.stateModalDownload = false;
  }

  onResponseModalDownloadDrf(event: any){
    this.stateModalDownloadDrf = false;
  }

  onResponseModalDownloadNewCmp(event: any){
    this.stateModalDownloadNewCmp = false;
  }

}

